const ToolboxInfo = {
  maxInstances: {
    controls_repeat_var_internal: 1,
    character_motion_move: 1,
    math_number: 1,
  },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "controls_repeat_var_internal",
          },
          {
            kind: "block",
            type: "character_motion_move",
          },
          {
            kind: "block",
            type: "math_number",
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
